export const selectBorderColor = ({ active = false, disabled = false, hasError = false, hover = false, readOnly = false }) => {
    if (hasError) {
        return 'tw-border-red-500 dark:tw-border-red-500';
    }
    if (active && !(disabled || readOnly)) {
        return 'tw-border-blue-700 dark:tw-border-blue-400';
    }
    if (hover && !(disabled || readOnly)) {
        return 'hover:tw-border-gray-600 dark:hover:tw-border-gray-600';
    }
    return 'tw-border-gray-300 dark:tw-border-gray-500 dark:tw-border-opacity-30';
};
//# sourceMappingURL=textarea.logic.js.map